import {
  MODEL_TYPE
} from './model_types'
import enumConstants from '../enumConstants.json'

export const ACCESS_USER_ENTITY_TYPE_TO_MODEL_TYPE = {
  [enumConstants.access_user_entity_types.EMPLOYEE]: MODEL_TYPE.EMPLOYEE
}

export const ACCESS_USER_ENTITY_TYPES_WITHOUT_ENTITY_MODEL = [
  enumConstants.access_user_entity_types.VISITOR,
  enumConstants.access_user_entity_types.RESOURCE
]
